module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/kulturniMapa-a0d5c0b3432ba654b63411de6d31fceb.svg";